import {BaseFormModel} from './base-form-model';
import {MenuModifier} from './menu-modifier';

export class MenuModifierGroupModifier extends BaseFormModel<MenuModifierGroupModifier> {
    id: number;
    menuModifier: MenuModifier;
    sortOrder: number;
    additionalPrice: number;
    defaultOption: number;
}
